import React from "react";

const STATUS_STYLES = {
  completed: {
    border: "border-[#22C55E]/40",
    bg: "bg-[#22C55E]/[0.04]",
    iconBg: "bg-[#22C55E]/10",
    icon: <i className="fa-solid fa-check text-[#22C55E] text-lg" />,
    label: "Selesai",
    labelColor: "text-[#22C55E]",
  },
  in_progress: {
    border: "border-[#0D75BC]/40",
    bg: "bg-[#0D75BC]/[0.04]",
    iconBg: "bg-[#0D75BC]/10",
    icon: null,
    label: "Sedang Dikerjakan",
    labelColor: "text-[#0D75BC]",
  },
  not_started: {
    border: "border-white/10",
    bg: "bg-white/[0.02]",
    iconBg: "bg-white/10",
    icon: null,
    label: "Belum Dimulai",
    labelColor: "text-white/30",
  },
};

const SectionCard = React.memo(function SectionCard({ section, status, onClick }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES.not_started;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`group w-full text-left px-6 py-6 desktop:px-8 desktop:py-6 rounded-2xl border
        ${s.border} ${s.bg} transition-all duration-300
        hover:bg-white/[0.06] hover:border-white/20 cursor-pointer`}
    >
      <div className="flex items-center gap-4">
        <div
          className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${s.iconBg}`}
        >
          {s.icon || (
            <i className={`${section.icon} text-white/60 text-lg`} />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-white font-sans text-base font-semibold mb-1">
            {section.title}
          </h3>
          <p className="text-white/40 font-sans text-sm">{section.subtitle}</p>
        </div>
        <div className="flex-shrink-0">
          <span className={`${s.labelColor} text-xs font-sans font-semibold`}>
            {s.label}
          </span>
        </div>
      </div>
    </button>
  );
});

export default SectionCard;
